import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-contactpersoon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-contactpersoon.component.html',
  styleUrl: './tekst-contactpersoon.component.scss',
})
export class TekstContactpersoonComponent {}
